// src/components/site/NavHighlight.tsx
"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

export function NavHighlight() {
  const path = usePathname();

  useEffect(() => {
    const schedule =
      "requestIdleCallback" in window
        ? (fn: () => void) => (window as any).requestIdleCallback(fn)
        : (fn: () => void) => setTimeout(fn, 1);

    schedule(() => {
      const nav = document.querySelector('nav[aria-label="Primary"]');
      if (!nav) return;

      const links = nav.querySelectorAll<HTMLAnchorElement>("a[data-href]");
      links.forEach((a) => {
        const href = a.getAttribute("data-href") || "/";
        const exact = a.getAttribute("data-exact") !== "0";
        const isActive = exact ? path === href : path.startsWith(href);

        if (isActive) {
          a.classList.add("font-semibold");
          a.setAttribute("aria-current", "page");
        } else {
          a.classList.remove("font-semibold");
          a.removeAttribute("aria-current");
        }
      });
    });
  }, [path]);

  return null;
}
